/**
 * useUserRoles
 * adapt USERROLES for foundations
 */

import { USERROLES } from 'containers/User/constants.js';
import { MEMBERTYPE_STAFF } from '../../constants.js';
import useIsFoundation from '../../../useIsFoundation.js';

function useUserRoles() {
  if (!useIsFoundation()) {
    return USERROLES;
  }
  return [{ id: MEMBERTYPE_STAFF, name: 'staff' }];
}

export default useUserRoles;
